var map = {
	"./big_smartsampa_logo_dark.png": 988,
	"./big_smartsampa_logo_light.png": 989,
	"./big_smartsampa_logo_lightAlt.png": 990,
	"./big_smartsampa_logo_mobile_dark.png": 565,
	"./big_smartsampa_logo_mobile_light.png": 566,
	"./big_smartsampa_logo_mobile_lightAlt.png": 567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;